module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":{"title":"Search","placeholder":"Type to search"}},"ua":{"search":{"title":"Пошук","placeholder":"Введіть для пошуку"}},"ru":{"search":{"title":"Поиск","placeholder":"Введите для поиска"}}}')
  delete Component.options._Ctor
}
